import store from "@/store";
if (!store.getters["unions/loaded"]) store.dispatch("unions/loadUnions");
if (!store.getters["professionalGroups/loaded"])
  store.dispatch("professionalGroups/loadProfessionalGroups");
if (!store.getters["services/loaded"]) store.dispatch("services/loadServices");

import {
  dictionaryConvert,
  fullName,
  humanizeDate
} from "@/components/Tables/formatters";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";
import ValuePickerFilterModel from "@/components/Tables/Filters/models/valuePickerFilterModel";
import DateFilterModel from "@/components/Tables/Filters/models/dateFilterModel";
import {
  isDeletedField,
  defaultHistoryFields
} from "@/components/Tables/defaultFields";
import { InitialState } from "@/components/Tables/Filters/models/tableFilter";

let peopleFields = [
  {
    key: "name",
    label: "Имя",
    filter: new StringFilterModel(),
    formatter: (value, key, { name, surname, patronymic }) =>
      fullName({ name, surname, patronymic })
  },
  {
    key: "sex",
    label: "Пол",
    filter: new ValuePickerFilterModel([
      {
        value: "М",
        text: "Мужской"
      },
      {
        value: "Ж",
        text: "Женский"
      }
    ]),
    formatter: value => dictionaryConvert(value, { "0": "Ж", "1": "М" })
  },
  {
    key: "birthday",
    label: "Дата рождения",
    filter: new DateFilterModel(),
    formatter: value => (value === null ? "Нет" : humanizeDate(value))
  },
  {
    key: "phones",
    label: "Номера телефонов",
    filter: new StringFilterModel(),
    formatter: value =>
      value
        .map(phone => {
          const { phone_number, has_telegram, has_viber, has_whatsapp } = phone;
          const messengers = [];
          if (has_telegram) messengers.push("T");
          if (has_viber) messengers.push("V");
          if (has_whatsapp) messengers.push("W");
          return `${phone_number} ${
            messengers.length > 0 ? `(${messengers.join(", ")})` : ""
          }`;
        })
        .join(", ")
  },
  {
    key: "comments",
    label: "Комментарии",
    filter: new StringFilterModel(),
    formatter: value => value.map(({ comment }) => comment).join(",")
  },
  {
    key: "email",
    label: "Адрес электронной почты",
    filter: new StringFilterModel()
  },
  {
    key: "union",
    label: "Профсоюз",
    filter: new StringFilterModel(),
    formatter: (value, key, { union_member_data: unionMemberData }) => {
      if (unionMemberData === null) return "Не член профсоюза";
      let unions = store.getters["unions/unions"];
      let { union_id: unionId } = unionMemberData;
      return unions.find(({ id }) => Number(id) === Number(unionId))?.name;
    }
  },
  {
    key: "unionJoinDate",
    label: "Дата вступления в профсоюз",
    filter: new DateFilterModel(),
    formatter: (value, key, { union_member_data: unionMemberData }) => {
      if (unionMemberData === null) return "Не член профсоюза";
      let { join_date: date } = unionMemberData;
      return date === null ? "Не указана" : humanizeDate(date);
    }
  },
  {
    key: "unionLeaveDate",
    label: "Дата выхода из профсоюза",
    filter: new DateFilterModel(),
    formatter: (value, key, { union_member_data: unionMemberData }) => {
      if (unionMemberData === null) return "Не член профсоюза";
      let { leave_date: date } = unionMemberData;
      return date === null ? "Не указана" : humanizeDate(date);
    }
  },
  {
    key: "position",
    label: "Должность",
    filter: new StringFilterModel(),
    formatter: (value, key, { employee_data: employeeData }) =>
      employeeData === null
        ? "Не работник предприятия"
        : employeeData.position !== null && employeeData.position.length > 0
        ? employeeData.position
        : "(Работник предприятия, но нет данных о должности)"
  },
  {
    key: "professionalGroup",
    label: "Профгруппа",
    filter: new StringFilterModel(),
    formatter: (value, key, { union_member_data: unionMemberData }) => {
      if (unionMemberData === null) return "Не член профсоюза";
      let { professional_group_id: professionalGroupId } = unionMemberData;
      if (professionalGroupId === null) return "Нет";
      else {
        let professionalGroups =
          store.getters["professionalGroups/professionalGroups"];
        return professionalGroups.find(
          ({ id }) => Number(id) === Number(professionalGroupId)
        )?.name;
      }
    }
  },
  {
    key: "service",
    label: "Служба",
    filter: new StringFilterModel(),
    formatter: (value, key, { employee_data: employeeData }) => {
      if (employeeData === null) return "Не работник предприятия";
      let { service_id: serviceId } = employeeData;
      if (serviceId === null) return "Нет";
      else {
        let services = store.getters["services/services"];
        return services.find(({ id }) => Number(id) === Number(serviceId))
          ?.name;
      }
    }
  }
];

if (store.getters["user/hasRole"](["root", "admin"]))
  peopleFields.push({
    key: "vip_status",
    label: "VIP-статус",
    filter: new ValuePickerFilterModel(
      [
        {
          value: false,
          text: "Нет"
        },
        {
          value: true,
          text: "Есть"
        }
      ],
      new InitialState([false, true])
    ),
    formatter: value => value !== null,
    display: false
  });

const personHistoryFields = [...peopleFields, ...defaultHistoryFields];

peopleFields.push(isDeletedField);

export { peopleFields, personHistoryFields };
